import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {
  BiddingSummaryCapagInfo,
  BiddingSummaryEditalDownload,
  BiddingSummaryTypes,
} from 'store/modules/bidding_summary_store/types';
import createTrack from 'services/actions/tracker_actions';
import { track } from 'services/tracking';
import { setCookie, hasCookie } from 'services/actions/cookies_actions';
import Onboarding from 'components/molecules/onboarding';
import iconIA from 'assets/images/icone-ia.svg';
import { Container } from './styles';

interface BiddingSummaryButtonProps {
  biddingId: number;
  editalDownload?: BiddingSummaryEditalDownload;
  capagInfo?: BiddingSummaryCapagInfo;
}

const BiddingSummaryButton = (props: BiddingSummaryButtonProps) => {
  const { biddingId, editalDownload, capagInfo } = props;
  const [previousBiddingId, setPreviousBiddingId] = useState<number>(0);
  const dispatch = useDispatch();

  const [showOnboarding, setShowOnboarding] = useState<boolean>(false);

  const openBiddingSummary = () => {
    setShowOnboarding(false);

    if (previousBiddingId !== biddingId && previousBiddingId !== 0)
      dispatch({ type: BiddingSummaryTypes.CLEAR_CURRENT_BIDDING_SUMMARY });

    if (previousBiddingId !== biddingId) setPreviousBiddingId(biddingId);

    dispatch({
      type: BiddingSummaryTypes.OPEN_BIDDING_SUMMARY,
      biddingId,
      editalDownload,
      capagInfo,
    });
  };

  useEffect(() => {
    const buttonList = document.getElementsByClassName('tour-bidding-summary');

    if (buttonList.length === 0) return;

    if (Number(buttonList[0].id) !== biddingId) return;

    if (hasCookie('onboardingBiddingSummaryShown')) return;

    setCookie('onboardingBiddingSummaryShown', true);
    setShowOnboarding(true);
  }, []);

  return (
    <Container className="d-inline-block badge-beta mr-1 mb-1 position-relative">
      <button
        id={biddingId.toString()}
        type="button"
        className="btn btn-sm btn-primary btn-ia tour-bidding-summary d-flex"
        onClick={() => {
          openBiddingSummary();
          createTrack('Resumo do Edital - Clicou no botão');
          track('edital.resumo_gerou');
        }}
      >
        <img alt="Icone IA" src={iconIA} height="18px" aria-hidden="true" className="mr-1" />
        Resumo do Edital
        <span className="badge badge-pill badge-beta position-absolute text-uppercase">Beta</span>
      </button>
      {showOnboarding && <Onboarding tourSelect="onboardingBiddingSummary" />}
    </Container>
  );
};

export default BiddingSummaryButton;
